import { createContext, useContext, useState, useEffect } from 'react';
import { ALLOWED_REGIONS } from '@src/utils';
import UpdateLocation from '@src/components/updateLocationModal';
import { Path } from '@src/navigations/routes';
import { useAccount } from '@src/contexts';

interface LocationContextType {
  isRestricted: boolean;
}

const LocationContext = createContext<LocationContextType | undefined>(undefined);

export const LocationProvider = ({ children }: { children: React.ReactNode }) => {
  const { userAddress } = useAccount();
  const [isRestricted, setIsRestricted] = useState<boolean>(false);

  useEffect(() => {
    if (userAddress && userAddress?.country === 'US') {
      setIsRestricted(userAddress.state ? !ALLOWED_REGIONS.includes(userAddress.state) : false);
    }
  }, [userAddress]);

  return (
    <LocationContext.Provider value={{ isRestricted }}>
      {isRestricted && (
        <UpdateLocation
          isOpen={isRestricted}
          handleClose={() => setIsRestricted(false)}
          url={`${Path.Profile}`}
        />
      )}
      {children}
    </LocationContext.Provider>
  );
};

export const useLocationContext = () => {
  const context = useContext(LocationContext);
  if (!context) {
    throw new Error('useLocationContext must be used within a LocationProvider');
  }
  return context;
};
